import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Tab, Tabs, Form, Row, Col } from 'react-bootstrap';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faCircleXmark, faTrashCan, faPencil, faEnvelope, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { Prev } from 'react-bootstrap/esm/PageItem';
import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";
import ImageUpload from '../../../Components/common/ImageUpload.js';
import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { ULDADDRESSSAVE, ULDSTATIONDETAILS, ULDADDRESSACTARC, ULDADDRESSRECMAIL, DELETERECEMAIL } from '../../../Utils/conts.js';
import { toast } from 'react-toastify';
import Trash from "../../../assets/images/trash.png";
import edit from "../../../assets/images/edit.png";

const SCM = () => {

    // console.log('999', rowData);
    const isMounted = useRef(false);
    const [formData, setFormData] = useState({});
    const [show, setShow] = useState(false);
    const [isEdit, setIsEdit] = useState('');
    const [showSCMModal, setShowSCMModal] = useState(false);
    const StationDetails = JSON.parse(localStorage.getItem('Handler_stn'));
    const modalShow = (pos) => {
        setShow(true);
        setIsEdit(pos);
        if (pos == 'add') {
            setInputAddress({ id: '', company_name: '', agent_or_handler: '', agent_type: 'E', address: '', email: [''], phone_number: '' })
        } else {
            const setData = { ...selectedRowData, agent_type: selectedRowData.agent_type ? selectedRowData.agent_type : selectedRowData.regd || '', address_id: selectedRowData.address_id }
            setInputAddress(setData);
        }
    }
    const modalClose = () => setShow(false);

    const [inputAddress, setInputAddress] = useState({
        id: '', company_name: '', agent_or_handler: '', agent_type: 'E', address: '', email: [''], phone_number: ''
    });
    const [address, setAddress] = useState();

    // console.log("🚀 ~ StationDetails ~ address:", address)
    // const dispatch = useDispatch();
    // Validation 
    const validateFormData = () => {
        let isValid = true;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        const validateEmail = (email) => {
            return emailRegex.test(email);
        };
        if (!inputAddress.company_name) {
            console.log('Text input is required');
            toast.error('Company Name must not be blank');
            isValid = false;
        } else if (!inputAddress.agent_or_handler) {
            console.log('Text input is required');
            toast.error('Please select Agent or Handler');
            isValid = false;
        }
        // else if (!inputAddress.address) {
        //     console.log('Text input is required');
        //     toast.error('Address must not be blank');
        //     isValid = false;
        // } else if (!inputAddress.phone_number) {
        //     console.log('Text input is required');
        //     toast.error('Phone Number must not be blank');
        //     isValid = false;
        // } else if (!/^\d{10}$/.test(inputAddress.phone_number)) {
        //     console.log('10');
        //     toast.error('Phone Number must be 10 Digits');
        //     isValid = false;
        // } else if (!inputAddress.email) {
        //     console.log('Text input is required');
        //     toast.error('Email must not be blank');
        //     isValid = false;
        // } else if (!validateEmail(inputAddress.email)) {
        //     console.log('Invalid email address');
        //     toast.error('Invalid email address');
        //     isValid = false;
        // }
        else {
            return isValid;
        }
    };

    const addAddress = async (e) => {
        // console.log('444', inputAddress);
        if (validateFormData()) {
            e.preventDefault();
            // const newAddressID = Math.floor(Math.random() * 1000000);
            // const stationid = rowData.station_id;
            const NewInputAddress = { ...inputAddress, station_id: 'stationid' };

            const dataToSend = {
                ...inputAddress,
                station_id: 'stationid',

                // company_name: inputAddress.company_name,
                // agent_or_handler: inputAddress.agent_or_handler,
                // address: inputAddress.address,
                // email: inputAddress.email,
                // phone_number: inputAddress.phone_number
            };
            // console.log("🚀 ~ addAddress ~ dataToSend:", dataToSend)

            if (inputAddress.agent_or_handler === 'A') {
                dataToSend.agent_type = inputAddress.agent_type;
            }

            // const updatedAddress = [...address, NewInputAddress];
            // if (updatedAddress) {
            //     dispatch(addAddressData(NewInputAddress)); // Pass sendStationData to addData thunk
            //   }
            if (NewInputAddress) {
                try {
                    const res = await withRFSToken.post(ULDADDRESSSAVE, dataToSend)
                        .then(function (res) {
                            // const innerData = res;
                            // console.log("🚀 ~ .then ~ innerData:", innerData)
                            if (res.data.response_code == 200) {
                                fetchDataGrid();
                                // setAddress(res.data.response_data);
                                setInputAddress({
                                    station_address_id: '', company_name: '', agent_or_handler: '', agent_type: 'E', address: '', email: [''], phone_number: ''
                                });
                                modalClose();
                                setSelectedRowData(res.data.response_data)
                            } else {
                                toast.error(res.data.response_msg);
                            }
                        });

                } catch (error) {
                    console.error('Error sending request:', error);
                }
            }

        }
    }
    // const handleChange = (e) => {
    //     setInputAddress({ ...inputAddress, [e.target.name]: e.target.value });
    // };

    // Email array start
    const handleEmailChange = (index, value) => {
        setInputAddress((prev) => {
            const updatedEmails = [...prev.email];
            updatedEmails[index] = value;
            return { ...prev, email: updatedEmails };
        });
    };

    const addEmailField = () => {
        setInputAddress((prev) => ({
            ...prev,
            email: [...prev.email, '']
        }));
    };

    const removeEmailField = (index) => {
        setInputAddress((prev) => ({
            ...prev,
            email: prev.email.filter((_, i) => i !== index)
        }));
    };
    // Email array end

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox' && name === 'regd') {
            setInputAddress({ ...inputAddress, [name]: checked ? '1' : '0' });
        } else {
            setInputAddress({ ...inputAddress, [name]: value });
        }
        // console.log(inputAddress);
    };



    const [selectedAddress, setSelectedAddress] = useState({});
    const [showEdit, setShowEdit] = useState(false);
    const modalEditShow = () => {
        setShowEdit(true);
        setInputAddress(selectedRowData)
    }
    const modalEditClose = () => setShowEdit(false);

    const handleEditChange = (e) => {
        setSelectedAddress(Prev => ({ ...Prev, [e.target.name]: e.target.value }));
    };

    const editAddress = async () => {
        // const updatedAddress = { ...selectedAddress, address_id: selectedAddress.address_id };
        try {
            const res = await withRFSToken.post(ULDADDRESSSAVE, inputAddress)
                .then(function (res) {
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    if (res.data.response_code == 200) {
                        const innerData = res.data.response_data;
                        // fetchDataGrid();
                        // setAddress(res.data.response_data);
                        setSelectedRowData(innerData);
                        const transformedData = {
                            ...innerData,
                            // agent_type: innerData.regd,
                            email: innerData.contact_email
                        };
                        setSelectedAddress(transformedData);
                        fetchDataGrid();
                        // setSelectedAddress({
                        //     company_name: '', agent_or_handler: '', agent_type: 'E', address: '', email: '', phone_number: ''
                        // });
                        modalEditClose();
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }
    // const [selectAddress, setSelectAddress] = useState(false);
    // const [selectedAddress, setSelectedAddress] = useState(null);

    // const addressDetails = (addressID) => {
    //     // Find the selected address by its addressID
    //     const updatedSelects = address.map(ads => ({ ...ads, selected: false }));
    //     const updatedSelect = updatedSelects.find(ads => ads.id === addressID);

    //     if (updatedSelect) {
    //         updatedSelect.selected = true;
    //     }
    //     setAddress(updatedSelects);
    //     // setSelectAddress(!selectAddress);
    //     const selected = address.find((addr) => addr.id === addressID);
    //     setSelectedAddress(selected);
    // };
    // Grid Start
    const [gridData, setGridData] = useState({
        Active: [],
        Archived: []

    });
    const fetchDataGrid = async () => {
        try {
            const res = await withRFSToken.post(ULDSTATIONDETAILS, { station_id: 'rowData.args.id' })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("casgdiuasduihasihdiuahsd",innerData)
                    setGridData({ Active: innerData.active_address, Archived: innerData.archive_address });
                    if (selectedRowData) {
                        if (activeTab === "Active") {
                            const activeData = innerData.active_address.find((e) => e.address_id == selectedRowData.address_id)
                            setSelectedRowData(activeData);
                            setAgentCodes(activeData.agent_codes)
                        }
                        else {
                            const archiveData = innerData.archive_address.find((e) => e.address_id == selectedRowData.address_id)
                            setSelectedRowData(archiveData);
                            setAgentCodes(archiveData.agent_codes)
                        }
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        fetchDataGrid();
        isMounted.current = true;
    }, []);
    const [activeTab, setActiveTab] = useState('Active');
    const [gridSelect, setGridSelect] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [showDetails, setShowDetails] = useState(false);

    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null)
    };

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };


    useEffect(() => {

        if (gridRefs[activeTab].current) { //  && !showDetails

            if (gridData[activeTab]) {
                //   const localData = gridData[activeTab].map(item => ({

                //     id: item.id,
                //     STN: item.station_code,
                //     Taddrs: item.station_addresses.length,
                //     Address: item.station_addresses // ?.join(', ')Join the address array into a string
                //   }));    
                // console.log("🚀 ~ localData ~ localData:", localData)
                const source = {
                    datatype: 'json',
                    id: `${activeTab}-`,
                    datafields: [
                        { name: 'address_id', type: 'string' },
                        { name: 'agent_codes', type: 'string' },
                        { name: 'address', type: 'string' },
                        { name: 'station_id', type: 'string' },
                        { name: 'company_name', type: 'string' },
                        { name: 'agent_or_handler', type: 'string' },
                        { name: 'regd', type: 'string' },
                        { name: 'email', type: 'string' },
                        { name: 'contact_email', type: 'string' },
                        { name: 'recovery_emails', type: 'string' },
                        { name: 'phone_number', type: 'string' },
                        { name: 'attachments', type: 'string' },
                    ],
                    localdata: gridData[activeTab],
                };

                const dataAdapter = new window.$.jqx.dataAdapter(source);
                // console.log('localdata', source.localdata)
                const columns = [
                    // { text: 'id', filtertype: 'textbox', datafield: 'id', width: '40%' },
                    {
                        text: 'Actions',
                        cellsrenderer: function () {
                            return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_delete" /></div>';
                        },
                        width: '16%', filterable: false,
                    },
                    { text: 'Airline Name', filtertype: 'textbox', datafield: 'company_name', width: '22%', cellclassname: '', },
                    {
                        text: 'Owner Code', filtertype: 'textbox', datafield: 'agent_or_handler',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue === 'A') {
                                return '<div class="s_register"> Agent </div>';
                            } else {
                                return '<div class="s_nonregister"> Handler </div>';
                            }
                        },
                        width: '20%', cellclassname: 'frcl',
                    },
                    {
                        text: 'Days of week', filtertype: 'textbox', datafield: 'regd',
                        cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
                            if (cellValue === 'E') {
                                return '<div class="s_register"> External </div>';
                            } else if (cellValue === 'I') {
                                return '<div class="s_nonregister"> Internal </div>';
                            } else {
                                return '<div class="s_nonregister"> </div>';
                            }
                        },
                        width: '18%', cellclassname: 'frcl',
                    },
                    { text: 'Warehouse Name', filtertype: 'textbox', datafield: 'warehouse_name', width: '19%', cellclassname: ''}
                ];

                const gridOptions = {
                    width: '100%',
                    source: dataAdapter,
                    columns: columns,
                    autoheight: true,
                    sortable: true,
                    altrows: false,
                    enabletooltips: true,
                    editable: false,
                    selectionmode: '',
                    pageable: false,
                    pageSize: 10,
                    pagerButtonsCount: 5,
                    pagerMode: 'advanced',
                    filterable: true,
                    filterrowheight: 45,
                    showfilterrow: true,
                    rowsheight: 42,
                    columnsheight: 45,

                };

                window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
                window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');

                window.$(gridRefs[activeTab].current).on('rowclick', (event) => {
                    // console.log('event', event);
                    const args = event.args.row.bounddata;
                    console.log('args', args);
                    if (args?.agent_codes?.length) {
                        const agentCodeList = args.agent_codes.map(code => ({
                            id: code.id,
                            agent_code: code.agent_code
                        }));
                        setAgentCodes(agentCodeList);
                    } else {
                        setAgentCodes([]);
                    }
                    const sendRowId = gridData[activeTab];
                    // console.log("🚀 ~ window.$ ~ sendRowId:", sendRowId)
                    setSelectedRowData(args, { station_id: args.uid });

                    setItems(args.recovery_emails)
                    setShowDetails(true);
                    const transformedData = {
                        ...args,
                        agent_type: args.regd,
                        // email: args.contact_email
                    };
                    setSelectedAddress(transformedData);
                    setEmailShow(false);
                });
                window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                    window.$(row).on('mouseover', () => {
                        window.$(row).addClass('row-hover');
                    });
                    window.$(row).on('mouseout', () => {
                        window.$(row).removeClass('row-hover');
                    });
                });
                // row selection by checkbox
                window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                    if (event.args.row) {
                        const selectedRow = event.args.row;
                        const selectedRowId = selectedRow.uid;
                        if (!gridSelect.some(row => row.uid === selectedRowId)) {
                            setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                        }
                    } else {
                        if (event.args.rowindex.length > 0) {
                            const allIds = gridData[activeTab];
                            setGridSelect(allIds);
                        } else {
                            setGridSelect([]);
                        }
                    }
                });
                window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                    if (event.args.row) {
                        const unselectedRowId = event.args.row.address_id;
                        setGridSelect(prevSelection => prevSelection.filter(row => row.address_id !== unselectedRowId));
                    }
                });
            } else {
                const columns = [
                    { text: 'Stations', filtertype: 'textbox', datafield: 'STN', width: '50%' },
                    { text: 'Total Address', filtertype: 'textbox', datafield: 'Taddrs', width: '50%' },
                ];
            }
        }
    }, [activeTab, gridData, showDetails]);
    // console.log('101', gridSelect);
    // row click function start
    const handleMoveToActArc = async () => {
        console.log('101', gridSelect);
        const sendAction = activeTab == 'Active' ? '0' : '1';
        if (gridSelect.length <= 0) {
            toast.error('Please select grid data before send');
        } else {
            const uldNumbers = gridSelect && gridSelect.map(num => num.address_id)
            try {
                const res = await withRFSToken.post(ULDADDRESSACTARC, { address_ids: uldNumbers, type: sendAction })
                    .then(function (res) {
                        if (res.data.response_code == 200) {
                            gridSelect.forEach(item => {
                                const selectedRowBoundIndex = item.boundindex;
                                window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                            });
                            setGridSelect([]);
                            fetchDataGrid()
                            if (activeTab == 'Active') {
                                toast.success('ULD Data moved to Arhive');
                                // fetchDataGrid()
                            } else {
                                toast.success('ULD Data moved to Active');
                                // fetchDataGrid()
                            }
                        }
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }
    }

    // Email section
    const emailArray = selectedRowData && selectedRowData.recovery_emails;
    // console.log("🚀 ~ StationDetails ~ emailArray:", emailArray)
    const [emailShow, setEmailShow] = useState(false);
    const inputEmailShow = () => setEmailShow(true);
    const [agentCodeShow, setAgentCodeShow] = useState(false);
    const addAgentCode = () => { setAgentCodeShow(true); console.log('101', selectedRowData) };
    const handleCloseAgentCode = () => { setAgentCodeShow(false) };
    const [inputData, setInputData] = useState("");
    const [items, setItems] = useState([]);
    const [agentCodes, setAgentCodes] = useState([]);
    const [editEmail, setEditEmail] = useState('');
    const [toggleButton, setToggleButton] = useState(false);


    const [isEditingAgentCode, setIsEditingAgentCode] = useState(false);
    const [editingAgentCodeId, setEditingAgentCodeId] = useState(null);

    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [agentCodeToDelete, setAgentCodeToDelete] = useState(null);

    const AddEmail = async () => {
        if (inputData == '') {
            // Alert('Please input Email');
            // console.log("Please input Email");
            document.getElementById('addEmail').classList.add('error');
            toast.error('Email address must not be blank');
            setEmailShow(true);
        }
        else if (inputData && toggleButton) {
            // if (index){
            const NewItemData = {
                // id: new Date().getTime().toString(),
                address_id: selectedRowData.address_id,
                recovery_email: inputData,
                email_key: editEmail,
            }
            // }
            try {
                const res = await withRFSToken.post(ULDADDRESSRECMAIL, NewItemData)
                    .then(function (res) {
                        if (res.data.response_code === 200) {
                            const innerData = res.data.response_data;
                            console.log("🚀 ~ .then ~ innerData:", innerData)
                            setItems(innerData);
                            // setExportGrid(innerData.export);
                            fetchDataGrid();
                        } else {
                            toast.error(res.data.response_msg)
                        }

                    });

            } catch (error) {
                console.error('Error fetching data:', error);
            }
            // setItems(items.map((elem) => {
            //     if(elem.id === editEmail){
            //         return {...elem, name: inputData}
            //     }
            //     return elem;
            // }));
            setInputData('');
            setEditEmail(null);
            setToggleButton(false);
            setEmailShow(false);
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const validateEmail = (email) => {
                return emailRegex.test(email);
            };
            if (!validateEmail(inputData)) {
                toast.error('Invalid email address');
                setEmailShow(true);
            } else {
                const NewItemData = {
                    // id: new Date().getTime().toString(),
                    address_id: selectedRowData.address_id,
                    recovery_email: inputData
                }
                try {
                    const res = await withRFSToken.post(ULDADDRESSRECMAIL, NewItemData)
                        .then(function (res) {
                            if (res.data.response_code === 200) {
                                const innerData = res.data.response_data;
                                console.log("🚀 ~ .then ~ innerData:", innerData)
                                setItems(innerData);
                                fetchDataGrid();
                            } else {
                                toast.error(res.data.response_msg);
                            }
                            // setExportGrid(innerData.export);
                        });

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
                // setItems([...items, NewItemData]);
                setEmailShow(false);
            }

            // localStorage.setItem('TruckerEmail', JSON.stringify(NewItemData));
        }
        setInputData('');
        // setEmailShow(false);

    }
    const handleKeyPress = () => { document.getElementById('addEmail').classList.remove('error'); }
    const deleteEmail = async (index) => {
        // const updatedItem = items.filter((curElem) => {
        //     return curElem.id !== index;
        // });
        try {
            const res = await withRFSToken.post(DELETERECEMAIL, { address_id: selectedRowData.address_id, email_key: index })
                .then(function (res) {
                    if (res.data.response_code === 200) {
                        const innerData = res.data.response_data;
                        console.log("🚀 ~ .then ~ innerData:", innerData)
                        toast.success(res.data.response_msg);
                        setItems(innerData);
                        fetchDataGrid();
                    } else {
                        toast.error(res.data.response_msg);
                    }

                    // setExportGrid(innerData.export);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
        // setItems(updatedItem);
    }
    const EditEmail = (index) => {
        // const email_toedit = items.find((elem) => {
        //     return elem.id == index;
        // });
        setEmailShow(true);
        setToggleButton(true);
        setInputData(items[index]);
        setEditEmail(index);
    }
    // Email section End
    const handleInputChange = (e) => {
        const value = e.target.value.toUpperCase();
        if (/^[A-Z0-9]*$/.test(value)) {
            setFormData((prev) => ({ ...prev, agent_code: value }));
        }
    };

    const handleAddAgentCode = async (e) => {
        const preparedData = {
            agent_code: formData.agent_code || '',
            station_id: selectedRowData?.station_id || '',
            address_id: selectedRowData?.address_id || '',
        };

        if (isEditingAgentCode && editingAgentCodeId) {
            preparedData.agent_code_id = editingAgentCodeId;
        }

        try {
            const res = await withRFSToken.post("uld-settings/set-agent-code", preparedData)
                .then(async function (res) {
                    if (res.data.response_code === 200) {

                        fetchDataGrid();

                    } else {
                        toast.error(res.data.response_msg)
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('An error occurred while saving the agent code.');
        }

        handleCloseAgentCode();
        setFormData({});
    };

    const handleDeleteClick = (agentCodeData) => {
        console.log("Trash icon clicked, attempting to show delete modal.", agentCodeData);
        setAgentCodeToDelete(agentCodeData);
        setShowDeleteConfirmModal(true);
    };

    const handleCloseDeleteConfirmModal = () => {
        setShowDeleteConfirmModal(false);
        setAgentCodeToDelete(null);
    };

    const confirmDeleteAgentCode = async () => {
        if (!agentCodeToDelete || !agentCodeToDelete.id) {
            toast.error("Invalid agent code data for deletion.");
            return;
        }

        const payload = {
            agent_code_id: agentCodeToDelete.id,
            action: "delete"
        };

        try {
            const res = await withRFSToken.post("uld-settings/set-agent-code-delete-revive", payload);
            if (res.data.response_code === 200) {
                const updatedAgentCodes = agentCodes.filter(code => code.id !== agentCodeToDelete.id);
                setAgentCodes(updatedAgentCodes);
                setSelectedRowData(prevData => ({
                    ...prevData,
                    agent_codes: updatedAgentCodes
                }));
                fetchDataGrid();
                toast.success(res.data.response_msg || "Agent code deleted successfully.");
            } else {
                toast.error(res.data.response_msg || "Failed to delete agent code.");
            }
        } catch (error) {
            console.error('Error deleting agent code:', error);
            toast.error("An error occurred while deleting the agent code.");
        } finally {
            handleCloseDeleteConfirmModal();
        }
    };

    const handleEditAgentCodeClick = (agentCodeData) => {
        const isAdd = !agentCodeData || agentCodeData.nativeEvent;
        if (isAdd) {
            setIsEditingAgentCode(false);
            setEditingAgentCodeId(null);
            setFormData({ agent_code: '' });
        } else {
            setIsEditingAgentCode(true);
            setEditingAgentCodeId(agentCodeData.id);
            setFormData({ agent_code: agentCodeData.agent_code });
        }

        setAgentCodeShow(true);
    };


    const handleOpenModal = () => {
        setShowSCMModal(true);
    }

    const handleModalClose = () => {
        setShowSCMModal(false);
    };

    return (
        <>
            <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right'>
                    <Row className='mt-3'>
                        <Col className='pt-4 px-4 brd_rgt' lg="6">
                            <h4>SCM Settings</h4>
                            <p>Add stations and manage stations by selecting the station.</p>

                            <div>
                                <button onClick={handleOpenModal} className={'exportbtn me-3 active'}>
                                    <span> <FontAwesomeIcon icon={faPlus} /> Add SCM Check</span>
                                </button>
                            </div>

                            <div className='addresses'>
                                <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="station_grid">
                                    <Tab eventKey="Active" title={<span>Active</span>} className='moveto'>
                                        <div className='moveto_btn'>
                                            <button onClick={handleMoveToActArc}> <img src={Arcv} /></button>
                                        </div>
                                        <div ref={gridRefs.Active} className='staion_grid' ></div>
                                    </Tab>
                                    <Tab eventKey="Archived" title={<span>Archived</span>} className='moveto'>
                                        <div className='moveto_btn'>
                                            <button onClick={handleMoveToActArc}> <img title='' src={Active} /></button>
                                        </div>
                                        <div ref={gridRefs.Archived} className='staion_grid' ></div>
                                    </Tab>
                                </Tabs>
                                {/* <Tabs defaultActiveKey={activeTab} onSelect={(tab) => handleTabChange(tab)} id="station-tabs" className="booking_tab">
                            <Tab eventKey="Active" title={<span>Active</span>} className='moveto'>
                                <div ref={gridRefs.Active} className='bookinggrid' ></div>
                            </Tab>
                            <Tab eventKey="Archived" title={<span>Archived</span>} className='moveto'>

                                <div ref={gridRefs.Archived} className='bookinggrid' ></div>
                            </Tab>
                        </Tabs> */}
                                {/* {address && address.map((ads, index) => ( */}
                                <>
                                    {/* {rowData.args.id === ads.id && (
        <> */}
                                    {/* <div key={ads.id} className={`addres_box ${ads.selected ? 'selectbx' : ''} `} onClick={() => addressDetails(ads.id)}>
                                    <ul key={index}>
                                        <h3>{ads.handler_name}</h3>

                                        <li><span>Address </span> : <span>{ads.address_1}</span></li>
                                        <li><span>Address 2 </span> : <span>{ads.address_2}</span></li>
                                        <li><span>Postal code </span> : <span>{ads.postal_code}</span></li>
                                        <li><span>Email </span> : <span>{ads.email}</span></li>
                                        <li><span>Phone No </span> : <span>{ads.phone_number}</span></li>
                                    </ul>
                                    <div className='confrm'><FontAwesomeIcon icon={faCircleCheck} /></div>
                                </div> */}
                                    {/* </>
    )} */}
                                </>
                                {/* ))} */}



                            </div>
                            {/* {console.log('666', selectedRowData)} */}
                        </Col>
                        <Col className='pt-4 px-4' lg="6">
                            {selectedRowData && (
                                <>
                                    <div className='handler_name'>
                                        <div className='raedit'><Button variant="link" onClick={() => modalShow('edit')}><FontAwesomeIcon icon={faPencil} /> Edit</Button></div>
                                        <h2>{selectedRowData.company_name}</h2>

                                        <div className='handler_info'>
                                            <ul>
                                                <h3>Handler Information</h3>
                                                <li><span>Agent/Handler </span> : <span>{selectedRowData.agent_or_handler == 'A' ? 'Agent' : 'Handler'}, {selectedRowData.address_2} </span></li>
                                                <li><span>Registered Hub</span> : <span>{selectedRowData.regd == '1' ? 'Registered' : 'Non Registered'}</span></li>
                                                <li><span>Contact Email </span> : <span>{selectedRowData.contact_email}</span></li>
                                                <li><span>Phone No </span> : <span>{selectedRowData.phone_number}</span></li>
                                                <li><span>Address </span> : <span>{selectedRowData.address}</span></li>
                                            </ul>
                                        </div>
                                        {selectedRowData.agent_or_handler === 'A' && (
                                            <div className='agent_codes'>
                                                <div className='d-flex justify-content-between py-2'>
                                                    <h6>Agent Codes</h6>
                                                    <div className='align-self-center'>
                                                        <button onClick={handleEditAgentCodeClick} className='add_adres'>+ Add Code</button>
                                                    </div>

                                                </div>
                                                <div className='showItem_agent'>
                                                    {agentCodes && agentCodes.map((elem, index) => {
                                                        console.log("Rendering agent code item:", elem);
                                                        return (
                                                            <div className='eachItem_agent' key={index}>
                                                                <h3>{elem.agent_code}</h3>
                                                                <div className='request_email'>
                                                                    <button onClick={() => handleEditAgentCodeClick(elem)}> <FontAwesomeIcon icon={faPencil} /> </button>
                                                                    <button onClick={() => handleDeleteClick(elem)}> <FontAwesomeIcon icon={faTrashCan} /> </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    }
                                                    )}
                                                    {console.log("Agent Codes array before map:", agentCodes)}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className='mt-3 '>
                                        <div className='d-flex justify-content-between py-2'>
                                            <h6>Recovery Email Address</h6>
                                            <div className='align-self-center'>
                                                <button onClick={inputEmailShow} className='add_adres'>+ Add Email</button>
                                            </div>

                                        </div>
                                        <div className='addresses'>
                                            {emailShow &&
                                                <>
                                                    <div className='add_email'>
                                                        <input name='' value={inputData} onKeyDown={handleKeyPress} onChange={(e) => setInputData(e.target.value)} id='addEmail' type='text' placeholder='Email type here' />
                                                        {toggleButton ? <button onClick={AddEmail}>Edit</button> : <button onClick={AddEmail}><FontAwesomeIcon icon={faPlus} /> Add</button>}
                                                    </div>
                                                </>
                                            }
                                            <div className='showItem'>{console.log('555', items)}
                                                {items && items.map((elem, index) => {
                                                    return (
                                                        <div className='eachItem' key={index}>
                                                            <h3><FontAwesomeIcon icon={faEnvelope} /> {elem}</h3>
                                                            {/* <button>Edit</button> */}
                                                            <div className='request_email'>
                                                                <button onClick={() => EditEmail(index)}> <FontAwesomeIcon icon={faPencil} /> </button>
                                                                <button onClick={() => deleteEmail(index)}> <FontAwesomeIcon icon={faTrashCan} /> </button>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <ImageUpload attachable_type={"uld_s_address"} attachable_id={selectedRowData.address_id} attachments={selectedRowData.attachments} />
                                </>
                            )}
                        </Col>
                    </Row>

                    <Modal show={show} onHide={modalClose} centered className='addfrom'>
                        <Modal.Header closeButton onClick={modalClose}>
                            <Modal.Title>{isEdit === 'edit' ? 'Edit' : 'Add'} Address - </Modal.Title>
                        </Modal.Header>
                        <Modal.Body >
                            <Form.Group className='mb-2'>
                                <Form.Label>Company Name</Form.Label>
                                <Form.Control type="text" onChange={handleChange} name='company_name' placeholder="Company Name" value={inputAddress.company_name} />
                            </Form.Group>
                            <Form.Group className='mb-2'>
                                <Form.Label>Agent or Handler</Form.Label>
                                <Form.Check
                                    inline
                                    label="Agent"
                                    name="agent_or_handler"
                                    type='radio'
                                    id='export'
                                    value='A'
                                    checked={inputAddress.agent_or_handler === 'A'}
                                    onChange={handleChange}
                                />

                                <Form.Check
                                    inline
                                    label="Handler"
                                    value="H"
                                    name="agent_or_handler"
                                    type='radio'
                                    id='import'
                                    checked={inputAddress.agent_or_handler === 'H'}
                                    onChange={handleChange}
                                />
                            </Form.Group>
                            {inputAddress.agent_or_handler == 'A' &&
                                <>
                                    <Form.Group className='mb-2'>
                                        <Form.Check
                                            inline
                                            label="External"
                                            name="agent_type"
                                            type='radio'
                                            id='external'
                                            value='E'
                                            checked={inputAddress.agent_type === 'E'}
                                            onChange={handleChange}
                                        />

                                        <Form.Check
                                            inline
                                            label="Internal"
                                            value="I"
                                            name="agent_type"
                                            type='radio'
                                            id='internal'
                                            checked={inputAddress.agent_type === 'I'}
                                            onChange={handleChange}
                                        />

                                    </Form.Group>
                                </>
                            }
                            <Form.Group className='mb-2'>
                                <Form.Label>Address </Form.Label>
                                <Form.Control type="text" onChange={handleChange} name='address' placeholder="Address" value={inputAddress.address} />
                            </Form.Group>
                            <Form.Group className='mb-2'>
                                <Form.Label>Email ID  <Link to="#" className="raad_adrss" onClick={addEmailField}>+ Add Email</Link></Form.Label>
                                {/* <Form.Control type="text" onChange={handleChange} name='email' placeholder="E-mail" /> */}
                                {inputAddress?.email?.map((email, index) => (
                                    <div key={index} className="d-flex align-items-center position-relative mb-2">
                                        <Form.Control
                                            type="text"
                                            placeholder="E-mail"
                                            value={email}
                                            onChange={(e) => handleEmailChange(index, e.target.value)}
                                            className=""
                                        />
                                        {inputAddress.email.length > 1 && (

                                            <Link to="#" onClick={() => removeEmailField(index)} className="email_del"> <FontAwesomeIcon icon={faCircleXmark} /> </Link>

                                        )}
                                    </div>
                                ))}
                            </Form.Group>
                            <Form.Group className='mb-2'>
                                <Form.Label>Telephone No</Form.Label>
                                <Form.Control
                                    type="number"
                                    onChange={handleChange}
                                    name='phone_number'
                                    onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 50); }}
                                    placeholder="Number"
                                    value={inputAddress.phone_number}
                                />
                            </Form.Group>

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" onClick={addAddress}  >
                                {isEdit === 'edit' ? 'Update' : 'Add'} Address
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={agentCodeShow} onHide={handleCloseAgentCode} centered className='addfrom'>
                        <Modal.Header closeButton>
                            <Modal.Title>{isEditingAgentCode ? 'Edit' : 'Add'} Agent Code</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <h6>{selectedRowData?.company_name} - </h6>
                            <Form.Group className='mb-3'>
                                <Form.Label>Agent Code</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Agent Code"
                                    value={formData.agent_code || ''}
                                    // maxLength={10}
                                    onChange={handleInputChange}
                                />
                                <Form.Text className="text-muted">
                                    Only capital letters (A-Z) and numbers (0-9) allowed.
                                </Form.Text>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant='primary' onClick={handleAddAgentCode}>
                                {isEditingAgentCode ? 'Update' : 'Add'}
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Delete Confirmation Modal */}
                    <Modal show={showDeleteConfirmModal} onHide={handleCloseDeleteConfirmModal} centered className="addfrom change_type">
                        <Modal.Header closeButton></Modal.Header>
                        <Modal.Body>
                            <h3>Delete Agent Code</h3>
                            <p>
                                Are you sure you want to delete the agent code:{" "}
                                <strong>{agentCodeToDelete?.agent_code}</strong>?
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="d-flex w-50 mx-auto are_bottom">
                                <Button variant="secondary" onClick={handleCloseDeleteConfirmModal}>
                                    No
                                </Button>
                                <Button variant="danger" onClick={confirmDeleteAgentCode}>
                                    Yes
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    <Modal show={showSCMModal} centered onHide={handleModalClose} className='addfrom staion_add' >
                        <Modal.Header closeButton>
                            <Modal.Title>Add SCM Check Rule </Modal.Title>
                            <p>Add an SCM Check Rule for specific airline (owner code)  </p>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group className='mb-2'>
                                <Form.Label>Airline Name</Form.Label>
                                <Form.Select aria-label="Default select example" name='search_area'>
                                    <option value=''>Select</option>
                                    <option value="awb_manager">AWB No.</option>
                                    <option value="booking_truck">Scheduled Truck</option>
                                </Form.Select>
                            </Form.Group>
                            <Form.Group className='mb-2'>
                                <Form.Label>Warehouse Name</Form.Label>
                                <Form.Select aria-label="Default select example" name='search_area'>
                                    <option value=''>Select</option>
                                    <option value="awb_manager">AWB No.</option>
                                    <option value="booking_truck">Scheduled Truck</option>
                                </Form.Select>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary">
                                Add Scm Check
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        </>
    )
}

export default SCM;